import { useQuery, useQueryClient } from "@tanstack/react-query";
import { create } from "zustand";
import { persist } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";

import { log } from "../logger";

export const AuthTokenLocalStorageKey = "AuthToken";


type Store = State & Actions;
type State = {
    isWebPlayLoginEnabled: boolean;
    isHeaderLoginEnabled: boolean;
    isUserProfileSettingsButtonEnabled: boolean;
    authToken: string | null;
};
type Actions = {
    enableWebPlayLogin: () => void;
    updateHeaderLogin: (newState: boolean) => void;
    updateUserProfileSettingsButton: (newState: boolean) => void;
    setAuthToken: (newState: string | null) => void;
};

const DEFAULT_STATE: State = {
    isWebPlayLoginEnabled: false,
    isHeaderLoginEnabled: true,
    isUserProfileSettingsButtonEnabled: true,
    authToken:  localStorage.getItem(AuthTokenLocalStorageKey)
};

export const useAppStore = create<Store>()(
    persist(
        immer((set) => ({
            ...DEFAULT_STATE,
            enableWebPlayLogin: () =>
                set((state) => {
                    state.isWebPlayLoginEnabled = true;
                }),
            updateHeaderLogin: (newState) =>
                set((state) => {
                    state.isHeaderLoginEnabled = newState;
                }),
            updateUserProfileSettingsButton: (newState) =>
                set((state) => {
                    state.isUserProfileSettingsButtonEnabled = newState;
                }),
            setAuthToken: (newState) =>
			{
				set((state) => {
					state.authToken = newState;
				});
				// TODO:  говно хак - так код писали обезьяны с гранатой, нужно удалить все из кеша react-query при смене токена
				// возможно надо как то более аккуратно чистить, но пока грохаю все
				log.info("Clearing react-query cache after auth token change");
				useQueryClient().clear();
			},
        })),
        {
            name: "app-store", // unique name for localStorage key
            partialize: (state) => ({
                  authToken: state.authToken
            })
        }
    )
);

export const useWebPlayLoginState = () => useAppStore((state) => state.isWebPlayLoginEnabled);

export const useHeaderLoginState = () => {
    const update = useAppStore((state) => state.updateHeaderLogin);
    const enabled = useAppStore((state) => state.isHeaderLoginEnabled);
    const enable = () => update(true);
    const disable = () => update(false);
    const reset = () => update(DEFAULT_STATE.isHeaderLoginEnabled);

    return [enabled, { enable, disable, reset }] as const;
};

export const useUserProfileSettingsButtonState = () => {
    const update = useAppStore((state) => state.updateUserProfileSettingsButton);
    const enabled = useAppStore((state) => state.isUserProfileSettingsButtonEnabled);
    const enable = () => update(true);
    const disable = () => update(false);
    const reset = () => update(DEFAULT_STATE.isUserProfileSettingsButtonEnabled);

    return [enabled, { enable, disable, reset }] as const;
};

export const appStore = {
    getState: useAppStore.getState,
    setState: useAppStore.setState,
    subscribe: useAppStore.subscribe
};
